import { ActionReducer } from '@ngrx/store';
import { StateManagementHelpers } from '../../helpers';
import * as FinancialProfileActions from '../actions/financial-profile.actions';
import { IFinancialProfileStore } from '../interfaces/financial-profile-store.interface';

const defaultFinancialProfile: IFinancialProfileStore = {
  invoiceAmount: { id: -1, value: '' },
  invoiceTerm: { id: -1, value: '' },
  bankStatementsComplete: false,
  balanceSheetsComplete: false,
  plStatementsComplete: false,
  arAgingComplete: false,
  apAgingComplete: false,
};

export const financialProfileReducer: ActionReducer<
  IFinancialProfileStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: IFinancialProfileStore = defaultFinancialProfile,
  action: any
): IFinancialProfileStore | undefined => {
  switch (action.type) {
    case FinancialProfileActions.INVOICE_AMOUNT:
      return StateManagementHelpers.mergeState(state, {
        invoiceAmount: action.invoiceAmount,
      }) as IFinancialProfileStore;
    case FinancialProfileActions.INVOICE_TERM:
      return StateManagementHelpers.mergeState(state, {
        invoiceTerm: action.invoiceTerm,
      }) as IFinancialProfileStore;
    case FinancialProfileActions.BANK_STATEMENTS_COMPLETE:
      return StateManagementHelpers.mergeState(state, {
        bankStatementsComplete: action.bankStatementsComplete,
      }) as IFinancialProfileStore;
    case FinancialProfileActions.BALANCE_SHEETS_COMPLETE:
      return StateManagementHelpers.mergeState(state, {
        balanceSheetsComplete: action.balanceSheetsComplete,
      }) as IFinancialProfileStore;
    case FinancialProfileActions.PL_STATEMENTS_COMPLETE:
      return StateManagementHelpers.mergeState(state, {
        plStatementsComplete: action.plStatementsComplete,
      }) as IFinancialProfileStore;
    case FinancialProfileActions.AR_AGING_COMPLETE:
      return StateManagementHelpers.mergeState(state, {
        arAgingComplete: action.arAgingComplete,
      }) as IFinancialProfileStore;
    case FinancialProfileActions.AP_AGING_COMPLETE:
      return StateManagementHelpers.mergeState(state, {
        apAgingComplete: action.apAgingComplete,
      }) as IFinancialProfileStore;
    case FinancialProfileActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        invoiceAmount: action.invoiceAmount,
        invoiceTerm: action.invoiceTerm,
        bankStatementsComplete: action.bankStatementsComplete,
        balanceSheetsComplete: action.balanceSheetsComplete,
        plStatementsComplete: action.plStatementsComplete,
        arAgingComplete: action.arAgingComplete,
        apAgingComplete: action.apAgingComplete,
      }) as IFinancialProfileStore;
    default:
      return state;
  }
};
